// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3R8qx","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3imi-"};